<div class="page-wrapper">
    <h1 class="page-header">YourOwnROOM Leadership</h1>
    <h2 class="page-subheader">Executive Officers</h2>
    <div class="row leadership-wrapper justify-content-center">
        
        <div class="col-lg-3 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#prabhatModal">
                <img src="../../assets/images/Team photo/PrabhatKumar.webp" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div style="display: flex; justify-content: center; align-items: center">
                    <h1 class="leader-name">Prabhat Kumar</h1>
                    <a style="margin-left: 8px" href="https://www.linkedin.com/in/prabhatkumartiwary/" target="_blank"><img src="../../assets/images/linkedinlogo.png" class="img-responsive linked-link" /></a>
                </div>
                <h3 class="leader-des">Founder, Managing Director & Group CEO </h3>
            </div>
        </div> 
        <div class="col-lg-3 offset-lg-1 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#sanjayModal">
                <img src="../../assets/images/Team photo/sanjay.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div style="display: flex; justify-content: center; align-items: center">
                    <h1 class="leader-name">Sanjay Singh</h1>
                    <a style="margin-left: 8px" href="https://www.linkedin.com/in/sanjay-singh-b620497/" target="_blank"><img src="../../assets/images/linkedinlogo.png" class="img-responsive linked-link" /></a>
                </div>
                <h3 class="leader-des"> Executive Director, COO & CTO </h3>
            </div>
        </div> 
    </div>
    <div class="alternate-section-wrapper">
    <h2 class="page-subheader">Board of Directors</h2>
    <div class="row leadership-wrapper justify-content-center">
        <div class="col-lg-3 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#prabhatModal">
                <img src="../../assets/images/Team photo/PrabhatKumar.webp" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div style="display: flex; justify-content: center; align-items: center">
                    <h1 class="leader-name">Prabhat Kumar</h1>
                    <a style="margin-left: 8px" href="https://www.linkedin.com/in/prabhatkumartiwary/" target="_blank"><img src="../../assets/images/linkedinlogo.png" class="img-responsive linked-link" /></a>
                </div>
                <h3 class="leader-des">Founder, Managing Director & Group CEO </h3>
            </div>
        </div>
	<div class="col-lg-3 offset-lg-1 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#sanjayModal">
                <img src="../../assets/images/Team photo/sanjay.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div style="display: flex; justify-content: center; align-items: center">
                    <h1 class="leader-name">Sanjay Singh</h1>
                    <a style="margin-left: 8px" href="https://www.linkedin.com/in/sanjay-singh-b620497/" target="_blank"><img src="../../assets/images/linkedinlogo.png" class="img-responsive linked-link" /></a>
                </div>
                <h3 class="leader-des"> Executive Director, COO & CTO </h3>
            </div>
        </div>
        <div class="col-lg-3 offset-lg-1 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#sachinModal">
                <img src="../../assets/images/Team photo/sachin.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div style="display: flex; justify-content: center; align-items: center">
                    <h1 class="leader-name">Sachin Joshi</h1>
                    <a style="margin-left: 8px" href="https://www.linkedin.com/in/sachin-joshi-0840753/" target="_blank"><img src="../../assets/images/linkedinlogo.png" class="img-responsive linked-link" /></a>
                </div>
                <h3 class="leader-des">Co-Founder, Non-Executive Director & Advisor</h3>
            </div>
        </div> 
        <!--<div class="col-lg-3 offset-lg-1 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
          //  <div class="img-wrapper" data-toggle="modal" data-target="#rewatModal" >
            //    <img src="../../assets/images/Team photo/Rewat.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            //</div>
            //<div class="leader-info">
              //  <div>
                //    <h1 class="leader-name">Dr. Rewat Laxman</h1>
                //</div>
                //<h3 class="leader-des">Co-Founder, Non-Executive Director & Advisor</h3>
            //</div>
        //</div>
        //<div class="col-lg-3 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
          //  <div class="img-wrapper"  data-toggle="modal" data-target="#narasimhaModal">
            //    <img src="../../assets/images/Team photo/narasimha.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
           // </div>
           // <div class="leader-info">
             //   <div>
               //     <h1 class="leader-name">K Narasimha Murthy</h1>
               // </div>
               // <h3 class="leader-des">Non-Executive Director & Advisor</h3>
            //</div>
	</div>-->
        <div class="col-lg-3 offset-lg-1 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#venkatModal">
                <img src="../../assets/images/Team photo/venkat.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div>
                    <h1 class="leader-name">Venkat Shiv Dasari</h1>
                </div>
                <h3 class="leader-des">Non-Executive Director & Advisor</h3>
            </div>
        </div>
    </div>
    </div>
    <h2 class="page-subheader">Board of Advisors</h2>
    <div class="row leadership-wrapper justify-content-center" >
        <div class="col-lg-3 col-md-3 col-sm-6 col-12 leadership-inner-wrapper">
            <div class="img-wrapper" data-toggle="modal" data-target="#raviModal">
                <img src="../../assets/images/Team photo/Ravi.jpg" class="img-responsive leader-image" alt="Prabhat Kumar Tiwary- YourOwnROOM"/>
            </div>
            <div class="leader-info">
                <div>
                    <h1 class="leader-name">Ravi Chaturvedi </h1>
                </div>
                <h3 class="leader-des">Advisor & Mentor</h3>
            </div>
        </div>
    </div>
</div>

<!-- Prabhat  Kumar-->
<div class="modal fade " id="prabhatModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name">Prabhat Kumar</h2>
                <h3 class="leader-des">Founder, CEO & Managing Director</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Prabhat is an alumni of Stanford Business School with over 27 years of experience in technology enterprises and startups. He is the Founder, CEO & Managing Director of YourOwnROOM, a prop-tech residential real estate asset management company that manages 1 million sqft of residential assets, valued at $50 million across Bangalore and Pune.
            </p>
            <p class="leader-cnt">
                He has worked in senior leadership and management positions in building and managing IT Services P&L of up to $100 M at Xchanging, MphasiS, Zensar and Hewlett-Packard. He also holds a bachelor’s degree in computer engineering from Birla Institute of Technology, Ranchi.
            </p>
            <p class="leader-cnt">
                Prabhat is very passionate about technology-based startups and likes to advise and work with them to scale them exponentially and profitably. He loves traveling and exploring new places around the world.
            </p>
        </div>
      </div>
    </div>
  </div>
  <!-- Sanjay Singh -->
  <div class="modal fade " id="sanjayModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name" id="exampleModalLabel">Sanjay Singh</h2>
                <h3 class="leader-des">COO & CTO </h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Sanjay has over 26 years of experience in Real Estate Rental & Property Management, Business Operations and Technology. He is the Chief Operating Officer & Chief Technology Officer at YourOwnROOM, a prop-tech residential real estate rental & property management company with a vision to deliver higher economic returns to both individual & institutional property owners over the property lifecycle. YourOwnROOM’s Asset Under Management is 1 million square feet valued at over Rs. 400 crores ($50 M) spread across 400 properties in Bangalore and Pune.
            </p>
            <p class="leader-cnt">
                He owns P&L and all operational and commercial activities related to Residential Rental(Co-living and Family homes) and Property Management business. He is passionate about delivering customer delight, thru operational excellence, asset and risk management, automation and transformation, to win Owner and Partner confidence.
            </p>
            <p class="leader-cnt">
                He has also worked in senior leadership and management positions for various Technology organizations like XChanging/DXC, HP, Sasken and Hinduja in India, US, UK and France. He has deep knowledge of technologies like ERPs, SaaS products, analytical reporting, and accounting, and believes it is key to delivering a differentiated Service.
            </p>
        </div>
      </div>
    </div>
  </div>
<!-- Sachin Joshi -->
  <div class="modal fade " id="sachinModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name" id="exampleModalLabel">Sachin Joshi</h2>
                <h3 class="leader-des">Co-Founder, Non-Executive Director & Advisor</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Sachin is a technology and business enthusiast with 21 years of experience working to create grounds up businesses and platforms.
            </p>
            <p class="leader-cnt">
                Sachin’s last 10 years of work experience has been in Real Estate Sector involving Commercial, Residential and Retail Real Estate. During this time he has established two businesses around Real Estate Technologies grounds up. Prior to his experience in Real Estate has worked in Industry Verticals in Energy, Manufacturing,Retail. He is a digital enthusiast with deep interest in Real Estate, Fin Tech, Technology and Economics.
            </p>
            <p class="leader-cnt">
                He has in depth experience of setting up digital busineses for conventional sectors. US, Europe and APAC are the global markets where he has actively worked setting up and delivering technology businesses. Sachin is focused on driving Strategy,Revenue and Product at YourOwnRoom. He loves to read stock reports, listen to international afffairs pod-casts and read books.
            </p>
            
        </div>
      </div>
    </div>
  </div>

  <!-- Rewat Laxman -->
  <div class="modal fade " id="rewatModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name" id="exampleModalLabel">Dr. Rewat Laxman</h2>
                <h3 class="leader-des">Co-Founder, Non-Executive Director & Advisor</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Dr. Rewat is the Director and Co-Founder of YourOwnROOM. It is his keen interest in the real estate market that has prompted him to be a part of this venture.
            </p>
            <p class="leader-cnt">
                Dr. Rewat Laxman is a Consultant Orthopedic surgeon practicing in Apollo Spectra in Bangalore.
            </p>
            <p class="leader-cnt">
                He completed his DNB Orthopaedics from Sparsh Hospitals Group, orthopedic residency in Bangalore Medical College and MBBS from JSSMC, Mysore. He did multiple fellowships in the field of arthroplasty, sports medicine, shoulder & elbow surgery in Europe and India.
            </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Narasimha Murthy -->
  <div class="modal fade " id="narasimhaModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name" id="exampleModalLabel">K Narasimha Murthy</h2>
                <h3 class="leader-des">Non-Executive Director & Advisor</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Narasimha Murthy is an alumnus of IIM Bangalore and Andhra University and has over 18 years of global experience in leading and managing Product Management & Development in the Healthcare Industry leveraging an array of technologies including Open Source. He is a Co-Founder of a Health Tech company and runs Product Development.
            </p>
            <p class="leader-cnt">
                He continuously promotes creativity and out of the box thinking believes it is critical in building commercial scale products and platforms, to sensibly and sensitively address market expectations.
            </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Venkat Dasari -->
  <div class="modal fade " id="venkatModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name">Venkat Shiv Dasari</h2>
                <h3 class="leader-des">Non-Executive Director & Advisor</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Venkat Shiv has held several prominent, global leadership positions. He is based out of Atlanta and leads Technology division for Products business unit in South east for Accenture advising CXO’s on Technology Transformations adding value to Business operations and revenue growth. Venkat Shiv’s area of expertise spans across the Retail and Consumer goods. He had a very long stint with Wipro in US and India.
            </p>
            <p class="leader-cnt">
                He has strong interest in Residential Real Estate in US and India and has made several investments. He is very passionate about building and supporting startups in US and India.
            </p>
        </div>
      </div>
    </div>
  </div>
  <!-- Ravi Chaturvedi -->
  <div class="modal fade " id="raviModal" tabindex="-1"  role="dialog" aria-labelledby="leaderModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header"  style="width: 100%" >
            <div style="width: 100%">
                <h2 class="leader-name">Ravi Chaturvedi</h2>
                <h3 class="leader-des">Advisor & Mentor</h3>
            </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="leader-cnt">
                Ravi has several prominent, global leadership positions. He is a Former President of P&G and the Former Group Chief Executive of Jet Airways. He is a Consultant and Advisor to the President and Chief Learning Officer of the Nitto Denko Corporation, Osaka, Japan. Ravi’s area of expertise spans across the consumer and food industries.
            </p>
            <p class="leader-cnt">
                Ravi was a Senior Fellow at Wharton School of Business and Lecturer, Organizational Dynamics Program, University of Pennsylvania; teaching "Globally Capable Leadership".
            </p>
        </div>
      </div>
    </div>
  </div>
